import update from 'immutability-helper'
import _ from 'lodash'
import {
    SPR_FILE_HISTORY_LOADED,
    NEW_FILE_UPLOADED,
    SPR_TASK_DELETED,
    SPR_TASK_STARTED,
    SPR_PRODUCTS_LOADED,
    SPR_PRODUCT_LOADED_BY_ID,
    SPR_MODEL_BASIC_VALUE_CHANGE,
    SPR_MODEL_DESCRIPTION_VALUE_CHANGE,
    SPR_MODEL_DATASHEET_VALUE_CHANGE
} from '../actions/types'

export default function ecommerce(state = {
    uploadHistory: [],
    sprProducts: {

    },
    sprModel: {
        id: null,
        spr_description: {},
        spr_data_sheet: {}
    }
}, action = {}) {
    switch(action.type) {
        case SPR_MODEL_BASIC_VALUE_CHANGE:
            return update(state,  {
                sprModel: {
                    [action.payload.field]: {$set: action.payload.value}
                }
            });

        case SPR_MODEL_DESCRIPTION_VALUE_CHANGE:
            return update(state, {
                sprModel: {
                    spr_description: {
                        [action.payload.index]: {$set: action.payload.value}
                    }
                }
            });

        case SPR_MODEL_DATASHEET_VALUE_CHANGE:
            return update(state, {
                sprModel: {
                    spr_data_sheet: {
                        [action.payload.key]: {
                            [action.payload.index]: {$set: action.payload.value}
                        }
                    }
                }
            });

        case SPR_PRODUCTS_LOADED:
            return update(state, {
                sprProducts: {$set: action.payload}
            });

        case SPR_PRODUCT_LOADED_BY_ID:
            return update(state, {
                sprModel: {$set: action.payload}
            });

        case SPR_FILE_HISTORY_LOADED:
            return update(state, {
                uploadHistory: {$set: action.payload}
            });

        case NEW_FILE_UPLOADED:
            return update(state, {
                uploadHistory: {
                    $unshift: [action.payload]
                }
            });

        case SPR_TASK_DELETED:
            return update(state, {
                uploadHistory: {
                    $splice: [[action.payload, 1]]
                }
            });

        case SPR_TASK_STARTED:
            return update(state, {
                uploadHistory: {
                    [action.payload.index]: {
                        $set: action.payload.newTask
                    }
                }
            })

        default: return state;
    }
}


// WEBPACK FOOTER //
// ./src/stores/ecommerce.js